// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cc23e1f3","634":"6e7881e4","969":"e7641d18"}[chunkId] + ".chunk.js";
};